import { fetcher } from '@weezevent/weezjs-core';

export async function fetchCommission(amount, organizationId, eventId, taxId, rateId = null, fromFinalPrice = true) {
    let queryParams = { price: parseFloat(amount).toFixed(2), id_tax: `${taxId}` };
    if (rateId) queryParams['rate'] = rateId;
    if (fromFinalPrice) queryParams['from_final_price'] = true;
    return fetcher.get(`/ticket/organizations/${organizationId}/events/${eventId}/rates/commission`, { query: queryParams });
}
